import { render, staticRenderFns } from "./Proximity.vue?vue&type=template&id=ae358246"
import script from "./Proximity.vue?vue&type=script&lang=js"
export * from "./Proximity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports